export const BADGE_SHAPES = [
    "angle",
    "burst",
    "burst-2",
    "calendar",
    "circle",
    "diamond",
    "free-lock",
    "half-pill",
    "rectangle",
    "star",
    "tag",
    "three-quarter-circle",
] as const;

export type BadgeShape = (typeof BADGE_SHAPES)[number];

// Shapes that are wider than they are tall ("long"). In Layout 2 these sit fine at the
// base position, so they are NOT lifted up the way the squarer/taller shapes are.
export const WIDE_BADGE_SHAPES = new Set<string>(["angle", "half-pill", "tag"]);
